/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Uploader_UploadingInputs */

const en_common_uploader_uploading = /** @type {(inputs: Common_Uploader_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uploading...`)
};

const zh_common_uploader_uploading = /** @type {(inputs: Common_Uploader_UploadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`上传中…`)
};

/**
* | output |
* | --- |
* | "Uploading..." |
*
* @param {Common_Uploader_UploadingInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const common_uploader_uploading = /** @type {((inputs?: Common_Uploader_UploadingInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Uploader_UploadingInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_common_uploader_uploading(inputs)
	return zh_common_uploader_uploading(inputs)
});
export { common_uploader_uploading as "common.uploader.uploading" }